import React, { useEffect, useState } from "react";
import AdminLayout from "../../layout/AdminLayout";
import { useParams } from "react-router-dom";
import { getEntertainmentVideoById } from "../../../api/entertainmentVideo.api";
import { baseURL } from "../../../api/api";
import { Link } from "react-router-dom";
import { FiPlus } from "react-icons/fi";

function EntertainmentVedioDetails() {
  const { id } = useParams();
  const [entertainmentVedioDetails, setEntertainmentVedioDetails] =
    useState(null);

  useEffect(() => {
    getEntertainmentVideoById(id)
      .then((res) => {
        console.log("Entertainment Video Details", res.data);
        setEntertainmentVedioDetails(res?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [id]);

  return (
    <>
      <AdminLayout title="Entertainment Video Details">
        <div className="mb-5 flex items-center justify-end sticky top-16 bg-slate-50 py-3 z-10 px-2">
          <Link
            to={`/infotainmentvideos/edit/${id}`}
            className="flex items-center justify-center rounded-md bg-yellowColor px-3 py-2.5 text-base font-semibold text-gray-700 shadow-sm hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-yellowColor"
          >
            <FiPlus className="text-lg text-gray-700" />
            Update Infotainment Video
          </Link>
        </div>

        <div className="px-10 gap-5 grid grid-cols-12">
          <div className="lg:col-span-8 md:col-span-8 col-span-12">
            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-12">
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Name
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {entertainmentVedioDetails?.name}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Location
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {entertainmentVedioDetails?.location}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-3 md:col-span-3 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Category
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {entertainmentVedioDetails?.category}
                </p>
              </div>
            </div>

            <div className="py-0.5 md:py-3 lg:py-3 items-center grid grid-cols-12">
              <div className="shadow-md p-3 mx-2 lg:col-span-4 md:col-span-12 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  Start Date
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {entertainmentVedioDetails?.startDate?.split("T")[0]}
                </p>
              </div>
              <div className="shadow-md p-3 mx-2 lg:col-span-4 md:col-span-12 col-span-12">
                <label className="block text-base font-semibold leading-6 text-gray-600">
                  End Date
                </label>
                <p className="mt-2 text-sm font-medium text-gray-600">
                  {entertainmentVedioDetails?.endDate?.split("T")[0]}
                </p>
              </div>
            </div>
          </div>

          <div className="lg:col-span-4 md:col-span-4 col-span-12">
            <div className="h-72 mt-2">
              <video
                src={`${baseURL}/s3/images/${entertainmentVedioDetails?.video?.name}`}
                alt="Selected"
                className="h-full w-full object-cover"
                controls
                muted
              />
            </div>
          </div>
        </div>
      </AdminLayout>
    </>
  );
}

export default EntertainmentVedioDetails;
